import React from 'react';
import { Row, Col, Typography, Avatar } from 'antd';
import { TwitterOutlined } from '@ant-design/icons';
import * as Config from '../../../Config';

const { Text, Title } = Typography;

const Footer = () => {
  return (
    <div>
      <Row style={{ padding: '4rem 0rem 4rem 0rem' }}>
        {/* Company */}
        <Col xs={24} md={{ span: 6, offset: 2 }} style={{ padding: '2rem' }}>
          {/* Logo */}
          <Title level={1} style={{ display: 'flex', alignItems: 'center' }}>
            <Avatar
              size={36}
              style={{ background: 'transparent', border: '1px solid #F56F7C' }}
              icon={
                <img
                  src={`${Config.app}/images/icons/new-icon-512x512.png`}
                  alt='logo'
                />
              }
            />
            &nbsp;Interact
          </Title>{' '}
          {/* Aim and moto */}
          <Row>
            <Col style={{ fontSize: '16px' }}>
              <Text>
                Big, small, online, offline, local. Size doesn't matter. We are
                doing everything to make lives better.
              </Text>
            </Col>
            {/* copyright */}
            <Col xs={24} style={{ marginTop: '1rem' }}>
              &copy; 2020 - <a href='https://rajchandra.me'>Raj Chandra</a>
            </Col>
          </Row>
        </Col>
        {/* Help Menu */}
        <Col xs={24} md={{ span: 6, offset: 2 }}>
          <Col style={{ padding: '2rem' }}>
            {/* Header */}
            <Title level={4}>Help Menu</Title> <br />
            {/* descriptiom */}
            <Row>
              {/* <Col xs={24}>Privacy</Col>
                            <Col xs={24}>Terms of Service</Col> */}
              <Col xs={24}>
                <a href='mailto:mail@rajchandra.me'>Contact</a>
              </Col>
              <Col xs={24}>
                <a href='https://rajchandra.me'>About</a>
              </Col>
            </Row>
          </Col>
        </Col>
        {/* Social Media */}
        <Col xs={24} md={{ span: 6, offset: 2 }}>
          <Col style={{ padding: '2rem' }}>
            {/* Header */}
            <Title level={4}>Social Media</Title> <br />
            {/* descriptiom */}
            <Row>
              <Col xs={24}>
                <a href='https://twitter.com/raj_chandra3'>
                  Follow on Twitter &nbsp;
                  <TwitterOutlined style={{ fontSize: '16px' }} />
                </a>
              </Col>
            </Row>
          </Col>
        </Col>
      </Row>
    </div>
  );
};

export default Footer;
